import { Icon } from '@seeqdev/qomponents';
import { useTranslation } from 'react-i18next';
import { WORKBOOK_DISPLAY } from '@/workbook/workbook.constants';
import { getWorkbookDisplayMode } from '@/main/routing.utilities';

export interface SummaryReportTitleHeaderProps {
  item: { id: string; name: string; color?: string };
  isPresentation?: boolean;
  onEdit: () => void;
  onDuplicate: () => void;
  onClose: () => void;
  extraClassNames?: string;
}

export const SummaryReportTitleHeader: React.FunctionComponent<SummaryReportTitleHeaderProps> = ({
  item,
  isPresentation,
  onEdit,
  onDuplicate,
  onClose,
  extraClassNames = '',
}) => {
  const { t } = useTranslation();
  const viewOnlyMode = getWorkbookDisplayMode() === WORKBOOK_DISPLAY.VIEW;

  return (
    <div className={`flexColumnContainer flexCenter ${extraClassNames}`}>
      <span key={item.id} className="flexFill flexColumnContainer flexAlignCenter mr10">
        <span
          className="flexCenter flexNoShrink mr5 circle width-16 height-16"
          style={{ backgroundColor: item.color || 'transparent' }}></span>
        <strong>{item.name}</strong>
      </span>
      {!isPresentation && (
        <div className="flexColumnContainer">
          {!viewOnlyMode && (
            <>
              <Icon icon="fa-pencil" type="theme" tooltip={t('EDIT')} extraClassNames="mr7" onClick={onEdit} />
              <Icon icon="fc-copy" type="theme" tooltip={t('DUPLICATE')} extraClassNames="mr7" onClick={onDuplicate} />
            </>
          )}
          <Icon icon="fa-close" type="theme" tooltip={t('CLOSE')} onClick={onClose} />
        </div>
      )}
    </div>
  );
};
